export const setTimeoutIfFuture = (cb, t) => {
  return t > 0 ? setTimeout(cb, t) : 0;
};
